import React from 'react';
import { UserRemoveIcon as HeroUserRemoveIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type UserRemoveIconProps = Omit<IconProps, 'children'>;

export const UserRemoveIcon: React.FC<UserRemoveIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroUserRemoveIcon />
        </Icon>
    );
};
